import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Icon} from 'semantic-ui-react';
import PartModels from '../../common/partModels';
import PartSubstitutes from '../../common/partSubstitute';
import PartEquivalences from '../../common/partEquivalences';
import './details.scss';

class ShowDetail extends Component {
  onCloseDetailClick() {
    this.props.onCloseDetailCard();
  }

  render() {
    const {itemSelected} = this.props;
    return (
      <div className='details-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>
                {itemSelected.partCode} - {itemSelected.name}
              </h2>
              <div className='title-bar-actions'>
                <Icon
                  link
                  name='close'
                  color='blue'
                  size='large'
                  onClick={this.onCloseDetailClick.bind(this)}
                />
              </div>
            </div>
          </div>

          <Grid textAlign='left'>
            <Grid.Row columns={4}>
              <Grid.Column width={8}>
                <PartModels partCode={itemSelected.partCode} />
              </Grid.Column>
              <Grid.Column width={4}>
                <PartSubstitutes partCode={itemSelected.partCode} />
                <h4>VIN:</h4>
                <p>{itemSelected.vin || '-'}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <PartEquivalences partCode={itemSelected.partCode} />
                <h4>Comentario:</h4>
                <p>{itemSelected.reasonDescription || '-'}</p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6}>
              <Grid.Column width={4}>
                <h4>Vehículo:</h4>
                <p>{itemSelected.vehicleDesc}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Origen:</h4>
                <p>{itemSelected.origen}</p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6}>
              <Grid.Column width={4}>
                <h4>Garantía:</h4>
                <p>{itemSelected.warranty}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Vehículo Inmovilizado:</h4>
                <p>{itemSelected.stopVeh}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Vehículo Nuevo:</h4>
                <p>{itemSelected.newVeh}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Peso:</h4>
                <p>{itemSelected.netWeight}</p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6}>
              <Grid.Column width={4}>
                <h4>Volumen:</h4>
                <p>{itemSelected.volumen}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Alto:</h4>
                <p>{itemSelected.height}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Ancho:</h4>
                <p>{itemSelected.width}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Largo:</h4>
                <p>{itemSelected.length}</p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6}>
              <Grid.Column width={4}>
                <h4>Stock TMC:</h4>
                <p>{itemSelected.stockTmc}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>Lead Time Producción:</h4>
                <p>{itemSelected.leadTime}</p>
              </Grid.Column>
              <Grid.Column width={4}>
                <h4>División Mensual:</h4>
                <p>{itemSelected.productionTime}</p>
              </Grid.Column>
              <Grid.Column width={4}>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerOrdersList.loading,
    'providersOrdersList': state.providerOrdersList.list,
  };
};

export default connect(mapStateToProps, {
})(ShowDetail);
